import {
  ADD_TOAST,
  REMOVE_TOAST,
  ADD_TOAST_FROM_QUEUE
} from "typeConstants";

// changed default to autohide = true so that multiple toasts eventually disappear.
const addToast = ({toast, type = "error", autohide = true}) => ({
  type: ADD_TOAST,
  toast,
  className: type,
  autohide,
});

const removeToast = () => ({
  type: REMOVE_TOAST
});

const addToastFromQueue = () => ({
  type: ADD_TOAST_FROM_QUEUE
});

const removeToastAndAddToastFromQueue = () => (dispatch, getState) => {
  const snackbar = getState().snackbar;
  if(snackbar.toasts.length) {
    return dispatch(removeToast()).then(() => {
      if (snackbar.toastsQueue.length) {
        setTimeout(function() {
          return dispatch(addToastFromQueue());
        }, 400);
      }
    });
  } else if (snackbar.toastsQueue.length) {
    setTimeout(function() {
      return dispatch(addToastFromQueue());
    }, 400);
  }
};

export {
  addToast,
  removeToast,
  removeToastAndAddToastFromQueue,
  addToastFromQueue
};
